// import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';

function App() {
  const [inputValue, setInputValue] = useState('');

  // function resp(d) {
  //   if(d===false){
  //     var zol = document.createElement("p")
  //     zol.className='otp'
  //     zol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> Thanks for asking me.  <br> Sorry I don't know the answer!</div>"
  //     document.getElementById('gpt').appendChild(zol)
  //   }
  //   else{
  //     var o = document.createElement("p")
  //     o.className='otp'
  //     o.innerHTML="<img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'>Thanks for asking me. <br> Here's my answer.. <br>"
  //     + d + "</div>"
  //     document.getElementById('gpt').appendChild(o)
  //   }
  // }  

  const check = pop => {
    var a = pop
    a = a.toUpperCase()
    if(a==='HI'){
      var o = document.createElement("p")
      o.className='otp'
      o.innerHTML="<img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'>Hi!<br>Thanks for using me.<br>How can I help you?"
      document.getElementById('gpt').appendChild(o)
    }
    else if(a===""){
      var olh = document.createElement("p")
      olh.className='otp'
      olh.innerHTML=
      "<img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'>Sorry, I couldn't understand. Please clarify your topic. <br>Thanks for using me."
      document.getElementById('gpt').appendChild(olh)
    }
    else if (a==="SUSHANT"){
      var aol = document.createElement("p")
      aol.className='otp'
      aol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> Sushant is my creator. You can find more about him in about section.</div>"
      document.getElementById('gpt').appendChild(aol)
    }
    else if (a==="SUSHANT NAIK"){
      var bol = document.createElement("p")
      bol.className='otp'
      bol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> Sushant is my creator. You can find more about him in about section.</div>"
      document.getElementById('gpt').appendChild(bol)
    }
    else if (a==="SUSHANT NAIK OFFICIAL"){
      var ccol = document.createElement("p")
      ccol.className='otp'
      ccol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> Sushant is my creator. You can find more about him in about section.</div>"
      document.getElementById('gpt').appendChild(ccol)
    }
    else if (a==="KUMPIX"){
      var ccdol = document.createElement("p")
      ccdol.className='otp'
      ccdol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> Do you want the info about me? <br> Kumpix offers you free service without any login or signup to find an absolute meaning or short descriptions of a word or a phrase.<br> A website by Sushant Naik @sushant_naik_official. You can find more about him in about section.</div>"
      document.getElementById('gpt').appendChild(ccdol)
    }
    else if (a==="SUSHANT M NAIK"){
      var dol = document.createElement("p")
      dol.className='otp'
      dol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> Sushant is my creator. You can find more about him in about section.</div>"
      document.getElementById('gpt').appendChild(dol)
    }
    else if (a==="SUSHANT MANJUNATH NAIK"){
      var eol = document.createElement("p")
      eol.className='otp'
      eol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> Sushant is my creator. You can find more about him in about section.</div>"
      document.getElementById('gpt').appendChild(eol)
    }
    else if (a==="HOW ARE YOU"){
      var fol = document.createElement("p")
      fol.className='otp'
      fol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'>I am fine. Thanks for asking </br> Feel free to ask anything..</div>"
      document.getElementById('gpt').appendChild(fol)
    }
    else if (a==="WHICH IS BEST IPL TEAM"){
      var gol = document.createElement("p")
      gol.className='otp'
      gol.innerHTML="   <img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%; display:inline;animation:img 1s;'><div style='display:inline-flex;'> <b>RCB<b></div>"
      document.getElementById('gpt').appendChild(gol)
    }
    else{
      var ol = document.createElement("p")
      ol.className='otp'
      fetch(`https://en.wikipedia.org/api/rest_v1/page/summary/${pop}`)
      .then(response => response.json())
      .then(data => {
        if(data.extract===undefined || data.extract === ""){
          ol.innerHTML= `<img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%;animation:img 1s;'><div>`+
          `<p>I could not find any information about "${pop}". Please try a different topic or check your spelling.</p> <br/>Thanks for using me.`;
        }
        else{
          ol.innerHTML= `<img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%;animation:img 1s;'><div>`+
          `<p>${data.extract}</p> <br/>Thanks for using me.`;} 
      })
      .catch(error => {
        console.error('Error fetching from Wikipedia:', error);
        ol.innerHTML= `<img src='favicon.ico' alt='!' style='height: 5vh; margin-right:2%;animation:img 1s;'><div>`+
        `<p>I could not find any information about "${pop}". Please try a different topic or check your spelling.</p> <br/>Thanks for using me.`;
        document.getElementById('gpt').appendChild(ol)
        document.getElementById('gpt').scrollIntoView(false)
      });
      document.getElementById('gpt').appendChild(ol)
    }
  }

  const handleKeyDown = (e) => {
    if(e.key==='Enter'){
      var a = document.createElement("p")
      a.className='inp'
      a.innerHTML=inputValue
      document.getElementById('gpt').appendChild(a)
      check(inputValue)
      setInputValue('')
    }
  }

  const handleClick = () => {
    var a = document.createElement("p")
    a.className='inp'
    a.innerHTML=inputValue
    document.getElementById('gpt').appendChild(a)
    check(inputValue)
    setInputValue('')
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <>
            <h1>Find short description on any topic</h1>
            <h2>On which topic do you want?</h2>
            <input 
              type="search" 
              name="src" 
              className='mb-3' 
              id="src" 
              autoFocus  
              placeholder="Enter here..." 
              aria-label="Recipient's username" 
              aria-describedby="basic-addon2"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <input 
              type="submit" 
              id='srch' 
              value="Search" 
              onClick={handleClick}
            />
            <div id="gpt"></div>
          </>
        } />
      </Routes>
    </Router>
  );
}

export default App;
